import engagebaySessionApi from "./authModule/api/sessionApi";
import { devLog } from "./commons/LogUtils";

export const getResellerInfo = async () => {
    try {
        const response = await engagebaySessionApi.get("/rest/api/jsp-dependencies/get-reseller-prefs", {});
        devLog("Reseller Response :: ", response.data);
        return response.data.prefs;
    } catch (error: any) {
        devLog("Error in getting reseller info ", error.response.data);
    }
}
